import { Component, OnInit, HostBinding } from '@angular/core';

@Component({
  selector: 'app-dropdown-itemgroup-label',
  templateUrl: './dropdown-itemgroup-label.component.html',
  styleUrls: ['./dropdown-itemgroup-label.component.scss']
})
export class DropdownItemgroupLabelComponent implements OnInit {
  @HostBinding('attr.role') private role = 'presentation';
  @HostBinding() public id: string;

  constructor() { }

  ngOnInit(): void {
  }

}
